import Colors from '@constants/Colors';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import Icons from './Icons';
import Text from './Text';
import { FlexRow } from './FlexRow';

type Props = {
    password: string;
};

const PasswordChecker = (props: Props) => {
    const [passed, setPassed] = useState<boolean[]>([]);
    useEffect(() => {
        const password = props.password ?? '';
        setPassed([
            /[A-Z]/.test(password),
            /[a-z]/.test(password),
            /[0-9]/.test(password),
            /[\.,;:!?+\-_@#$]/.test(password),
        ]);
    }, [props.password]);

    return (
        <Grid container spacing={1} marginBottom={2}>
            <Grid item>
                <Text gray medium>
                    Pour sécuriser votre mot de passe, celui-ci doit comporter au moins 8 caractères dont au moins :
                </Text>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FlexRow>
                    <Icons
                        name="check"
                        size={18}
                        color={passed[0] ? Colors.PRIMARY : Colors.NEUTRAL_GRAY}
                    />
                    <Text gray medium size={12} primary={passed[0]}>
                        {' '}
                        Une majuscule
                    </Text>
                </FlexRow>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FlexRow>
                    <Icons
                        name="check"
                        size={18}
                        color={passed[1] ? Colors.PRIMARY : Colors.NEUTRAL_GRAY}
                    />
                    <Text gray medium size={12} primary={passed[1]}>
                        {' '}
                        Une minuscule
                    </Text>
                </FlexRow>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FlexRow>
                    <Icons
                        name="check"
                        size={18}
                        color={passed[2] ? Colors.PRIMARY : Colors.NEUTRAL_GRAY}
                    />
                    <Text gray medium size={12} primary={passed[2]}>
                        {' '}
                        Un chiffre
                    </Text>
                </FlexRow>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FlexRow>
                    <Icons
                        name="check"
                        size={18}
                        color={passed[3] ? Colors.PRIMARY : Colors.NEUTRAL_GRAY}
                    />
                    <Text gray medium size={12} primary={passed[3]}>
                        {' '}
                        Un caractère spécial (.,;:!?+-_@#$)
                    </Text>
                </FlexRow>
            </Grid>
        </Grid>
    );
};

export default PasswordChecker;
